<template>
  <div class="product-details-content-setup-step-01">
    <div class="mb-5">
      <step-title
        title="Informações básicas"
        description="Através dessas informações seu cliente vai identificar o seu produto."
        icon="fa-solid fa-circle-info"
      />
    </div>

    <form-group
      v-model="form.name"
      id="name"
      label="Nome da área de membros"
      placeholder="Alunos"
      :errors="errors.name"
      required
    />
    <div class="d-flex justify-content-end mb-5">
      <small
        class="text-secondary"
        :class="{
          'text-danger': form.name && form.name.length > 250
        }"
      >
        {{ `${form.name ? form.name.length : 0}/250` }}
      </small>
    </div>

    <div class="mb-6">
      <form-group
        v-model="form.description"
        id="description"
        label="Descrição (SEO)"
        placeholder="Escreva uma descrição do seu curso"
        :errors="errors.description"
        textarea
        rows="4"
        required
      />
      <div class="d-flex justify-content-between mb-5">
        <small class="text-secondary">
          A Descrição é o texto geralmente exibido pelo Google nas segundas e
          terceiras linhas dos resultados de busca. Crie uma Descrição que
          estimule o interesse das pessoas em saber mais sobre o seu conteúdo.
        </small>
        <small
          class="text-secondary"
          :class="{
            'text-danger': form.description && form.description.length > 255
          }"
        >
          {{ `${form.description ? form.description.length : 0}/255` }}
        </small>
      </div>
    </div>

    <b-form-checkbox id="showcase" v-model="form.showcase" switch>
      Exibir na vitrine
    </b-form-checkbox>

    <div v-if="form.showcase">
      <form-group
        v-model="form.link_sale_page"
        id="link-sale-page"
        label="Conheça o curso"
        placeholder="Link da página de vendas"
        :errors="errors.link_sale_page"
      />
      <small class="text-secondary">
        Insira aqui o link de uma página que descreva seu curso.
      </small>
    </div>

    <div class="mt-6 mb-3">
      Personalização de domínio
    </div>
    <div class="d-md-flex">
      <form-group
        v-model="form.subdomain"
        id="subdomain"
        label="Subdomínio"
        class="flex-fill"
        placeholder="seu-produto"
        :errors="errors.subdomain"
        setFocusOnError
        required
      />
      <strong class="mt-9 pt-5 pl-3">
        .club.app2sales.com.br
      </strong>
    </div>

    <form-group
      v-model="form.domain"
      id="domain"
      label="Domínio próprio (opcional)"
      class="flex-fill"
      placeholder="https://seu-produto.com.br"
      :errors="errors.domain"
      setFocusOnError
    />
    <small class="text-secondary">
      Necessário ajustar o CNAME do domínio para <b>cname.velora.com.br</b>
    </small>

    <div class="mt-6 mb-3">
      Prazo de acesso na área de membros
    </div>
    <div class="d-flex ">
      <form-group
        class=" flex-fill"
        id="access_period"
        label="Período de acesso"
        placeholder="Ilimitado"
        select
        v-model="form.access_period"
        :options="periodOptions"
        :errors="errors.access_period"
      />
      <form-group
        v-show="form.access_period != 'unlimited_access'"
        class="ml-3 flex-fill"
        id="access_unit"
        mask="####"
        :label="`${periodPt[form.access_period]} de acesso`"
        placeholder="0"
        v-model="form.access_unit"
        :errors="errors.access_unit"
      />
    </div>
    <small class="text-secondary">
      Insira aqui o periodo de acesso do aluno à Área de Membros.
    </small>

    <div class="mt-6 mb-3">
      Definição de Senha Padrão
    </div>
    <div class="align-items-end">
      <form-group
        v-model="form.password_default"
        id="password_default"
        label="Senha padrão"
        class="flex-fill"
        placeholder="********"
        :errors="errors.password_default"
      />
      <small class="text-secondary">
        Configure uma senha de acesso a sua Área de Membros. Válida apenas para
        alunos.
      </small>
    </div>
    <div class="mt-6 mb-6">
      Redes Sociais
    </div>
    <div class="d-flex">
      <b-form-checkbox
        id="social-media-members"
        v-model="form.social_media_enabled"
        variant="primary"
        switch
        :class="{ 'text-primary': form.social_media_enabled }"
      >
        Ativar redes sociais na área de membros
      </b-form-checkbox>
    </div>

    <div
      class="social-media"
      :class="{ hide: this.form.social_media_enabled == false }"
      v-if="form.social_media"
    >
      <div class="align-items-end d-flex mt-5">
        <i class="fa-brands fa-instagram mr-3 mb-6" />
        <form-group
          v-model="form.social_media.instagram"
          id="instagram_url"
          label="Instagram"
          class="flex-fill"
          placeholder="instagram.com/seu-perfil"
        />
      </div>

      <div class="align-items-end d-flex mt-3">
        <i class="fa-brands fa-facebook mr-3 mb-6" />
        <form-group
          v-model="form.social_media.facebook"
          id="facebook_url"
          label="Facebook"
          class="flex-fill"
          placeholder="facebook.com/sua-pagina"
        />
      </div>

      <div class="align-items-end d-flex mt-3">
        <i class="fa-brands fa-youtube mr-3 mb-6" />
        <form-group
          v-model="form.social_media.youtube"
          id="youtube_url"
          label="Youtube"
          class="flex-fill"
          placeholder="youtu.be/id_youtube"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import { getToken } from "@/setup/api";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    periodOptions() {
      return [
        { id: "unlimited_access", name: "Ilimitado" },
        { id: "days", name: "Dias" },
        { id: "months", name: "Meses" },
        { id: "years", name: "Anos" }
      ];
    },
    periodPt() {
      return {
        unlimited_access: "Ilimitado",
        days: "Dias",
        months: "Meses",
        years: "Ano"
      };
    }
  },
  watch: {
    "form.access_period"(val) {
      if (val === "unlimited_access") {
        this.form.access_unit = null;
      }
    },
    "form.social_media_enabled"(val) {
      if (val === false) {
        this.form.social_media = {
          instagram: "",
          facebook: "",
          youtube: ""
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-setup-step-01 {
  .social-media {
    overflow: hidden;
    height: 333px;
    transition: 0.2s all;
    &.hide {
      height: 0px;
    }
  }
  .fa-brands {
    color: rgba(87, 88, 107, 0.88);
    font-size: 20px;
  }
}
</style>
